import { INIT } from './app';
import api from './../lib/api';

const CREAETE_CENTER = 'playground/centers/create';
const UPDATE_CENTER = 'playground/centers/update';
const DELETE_CENTER = 'playground/centers/delete';
const FETCH_CENTERS = 'playground/centers/fetch';

function asCenterList(value) {
  if (Array.isArray(value)) return [...value];
  if (value && Array.isArray(value.items)) return [...value.items];
  if (value && Array.isArray(value.$values)) return [...value.$values];
  if (value && Array.isArray(value.data)) return [...value.data];
  return null;
}

function keepOrReplace(state, incoming) {
  if (incoming && incoming.length > 0) return incoming;
  if (Array.isArray(state) && state.length > 0) return state;
  return incoming || [];
}

const reducer = (state = [], action) => {
  switch (action.type) {
    case INIT:
      return keepOrReplace(state, asCenterList(action.payload && action.payload.centers));
    case FETCH_CENTERS:
      return keepOrReplace(state, asCenterList(action.payload));
    case CREAETE_CENTER:
      return [...state, action.payload];
    case UPDATE_CENTER:
      return state.map(c => (c.id === action.payload.id ? { ...c, ...action.payload } : c));
    case DELETE_CENTER:
      return state.filter(center => center.id !== action.payload.id);
    default:
      return state;
  }
};

export const createCenter = async ({
  name,
  address,
  description,
  type,
  latitude,
  longitude,
  showers,
  chairlift,
  dragLift,
  poolBilliards,
  russianBilliards,
  snookerBilliards,
  ski,
  snowboard,
  rent,
  protection,
  inventory,
  lockers,
  parking,
  toilets,
  alter,
  city,
  countryCode,
  timeZone,
}) => {
  const model = {
    name,
    address,
    description,
    type,
    latitude: latitude === '' ? null : latitude,
    longitude: longitude === '' ? null : longitude,
    showers,
    lockers,
    parking,
    toilets,
    alter,
    chairlift,
    dragLift,
    poolBilliards,
    russianBilliards,
    snookerBilliards,
    ski,
    snowboard,
    rent,
    protection,
    inventory,
    city,
    countryCode: countryCode || null,
    timeZone: timeZone ? { id: timeZone.id || timeZone.Id } : null, // Убеждаемся, что timeZone в правильном формате
  };

  const response = await api.createCenter(model);
  return {
    type: CREAETE_CENTER,
    payload: response,
  };
};

export const updateCenter = async ({
  id,
  name,
  address,
  description,
  type,
  latitude,
  longitude,
  showers,
  chairlift,
  dragLift,
  poolBilliards,
  russianBilliards,
  snookerBilliards,
  ski,
  snowboard,
  rent,
  protection,
  inventory,
  lockers,
  parking,
  toilets,
  alter,
  city,
  countryCode,
  timeZone,
}) => {
  const model = {
    id,
    name,
    address,
    description,
    type,
    latitude: latitude === '' ? null : latitude,
    longitude: longitude === '' ? null : longitude,
    showers,
    lockers,
    parking,
    toilets,
    alter,
    chairlift,
    dragLift,
    poolBilliards,
    russianBilliards,
    snookerBilliards,
    ski,
    snowboard,
    rent,
    protection,
    inventory,
    city,
    countryCode: countryCode || null,
    timeZone: timeZone ? { id: timeZone.id || timeZone.Id } : null, // Убеждаемся, что timeZone в правильном формате
  };
  const response = await api.updateCenter(model);
  return {
    type: UPDATE_CENTER,
    payload: response,
  };
};

export const deleteCenter = async (id) => {
  const response = await api.deleteCenter(id);
  return {
    type: DELETE_CENTER,
    payload: response,
  };
};

export const fetchCenters = async () => {
  const centers = await api.getCenters();
  if (!Array.isArray(centers) && !(centers && (centers.items || centers.$values || centers.data))) {
    throw new Error('Некорректный ответ списка клубов');
  }
  return {
    type: FETCH_CENTERS,
    payload: centers,
  };
};

/** Одобрить спорткомплекс (админ). redux-promise подставит результат в store. */
export const approveSportComplex = (id) => ({
  type: UPDATE_CENTER,
  payload: api.approveSportComplex(id),
});

/** Отклонить спорткомплекс (админ). redux-promise подставит результат в store. */
export const rejectSportComplex = (id) => ({
  type: UPDATE_CENTER,
  payload: api.rejectSportComplex(id),
});

export default reducer;
